import { injectPrimitive } from '../../../../../../common/store/base/injectPrimitive';
import { inject } from '../../../../../../common/container/inject';
import { IPrimitiveStore } from '../../../../../../common/store/interface/IPrimitiveStore';
import { ILocalization, ILocalizationToken } from '../../../../../../application/language/ILocalization';
import { IProjectModel } from '../../../../../../service/project/IProjectModel';
import { ApplicationRoutes } from '../../../../../../application/constants/routes';
import { IAnalyticsPageHeaderBreadcrumb } from '../../main/parts/AnalyticsPageHeader';
import { CREATE_ANALYTICS_ROOT_BREADCRUMB } from '../../main/parts/analyticsHeaderBreadcrumbs';
import { IAnalyticsProjectDomain } from './IAnalyticsProjectDomain';
import { IAnalyticsProjectUI } from './IAnalyticsProjectUI';

export class AnalyticsProjectUI implements IAnalyticsProjectUI {
  isFetchingProject: IPrimitiveStore<boolean>;
  project: IPrimitiveStore<IProjectModel | null>;
  breadcrumbs: IPrimitiveStore<IAnalyticsPageHeaderBreadcrumb[]>;

  constructor(
    private analyticsProjectDomain: IAnalyticsProjectDomain,
    private projectId?: string,
    private i18n = inject<ILocalization>(ILocalizationToken),
  ) {
    this.isFetchingProject = injectPrimitive(Boolean(projectId));
    this.project = injectPrimitive<IProjectModel | null>(null);
    this.breadcrumbs = injectPrimitive<IAnalyticsPageHeaderBreadcrumb[]>([
      CREATE_ANALYTICS_ROOT_BREADCRUMB(this.i18n.translate('analytics.title')),
    ]);
  }

  boot = async () => {
    if (!this.projectId) {
      this.project.setValue(null);
      this.isFetchingProject.setValue(false);
      this.breadcrumbs.setValue([CREATE_ANALYTICS_ROOT_BREADCRUMB(this.i18n.translate('analytics.title'))]);
      return;
    }

    this.isFetchingProject.setValue(true);

    try {
      const project = await this.analyticsProjectDomain.getProjectById(this.projectId);

      this.project.setValue(project);
      this.breadcrumbs.setValue([
        CREATE_ANALYTICS_ROOT_BREADCRUMB(this.i18n.translate('analytics.title')),
        {
          label: project.name,
          link: ApplicationRoutes.AnalyticsProject.replace(':projectId', this.projectId),
        },
      ]);
    } finally {
      this.isFetchingProject.setValue(false);
    }
  };
}
